module.exports = __webpack_public_path__ + "img/16.89f1b53e.webp";